import { Routes } from '@angular/router';
import { authGuard } from './features/auth/guards/auth.guard';
import { customerGuard } from './features/auth/guards/customer/customer.guard';
import { salonOwnerGuard } from './features/auth/guards/salon-owner/salon-owner.guard';
import { hairdresserGuard } from './features/auth/guards/hairdresser/hairdresser.guard';
import { noHairdresserGuard } from './features/auth/guards/no-hairdresser/no-hairdresser.guard';
import { hasServicesGuard } from './features/auth/guards/has-services/has-services.guard';
import { noServicesGuard } from './features/auth/guards/no-services/no-services.guard';
import { NotFoundComponent } from "./features/not-found/not-found.component";

export const appRoutes: Routes = [
  {
    path: '',
    loadChildren: (): Promise<Routes> => import('./features/home/home.routes').then(r => r.HOME_ROUTES),
    canActivate: [noHairdresserGuard]
  },
  {
    path: 'home',
    redirectTo: '',
    pathMatch: 'full'
  },
  // Couvre aussi /hairdressers/city et /hairdressers/:username, désormais
  // déclarées en enfants (cf. hairdressers.routes.ts). canActivate sur le
  // parent s'applique à tous les enfants, comme c'était le cas auparavant.
  {
    path: 'hairdressers',
    loadChildren: (): Promise<Routes> => import('./features/hairdressers/hairdressers.routes').then(r => r.hairdressersRoutes),
    canActivate: [noHairdresserGuard]
  },
  {
    path: 'salons/:id',
    loadComponent: () => import('./features/salon-public/salon-public.component').then(m => m.SalonPublicComponent)
  },
  {
    path: 'book/:username/:serviceSlug',
    loadChildren: (): Promise<Routes> => import('./features/quick-booking/quick-booking.routes').then(r => r.quickBookingRoutes)
  },
  {
    path: 'book/:username',
    loadChildren: (): Promise<Routes> => import('./features/quick-booking/quick-booking.routes').then(r => r.quickBookingRoutes)
  },
  {
    path: 'hairstyles',
    loadChildren: (): Promise<Routes> => import('./features/hairstyles/hairstyles.routes').then(r => r.HairstylesRoutes),
    canActivate: [noHairdresserGuard]
  },
  {
    path: 'boutique',
    loadChildren: (): Promise<Routes> => import('./features/shop/shop.routes').then(r => r.SHOP_ROUTES)
  },
  {
    path: 'auth',
    loadChildren: (): Promise<Routes> => import('./features/auth/auth.routes').then(r => r.authRoutes)
  },
  {
    path: 'profile/customer',
    loadChildren: (): Promise<Routes> => import('./features/customer-profile/customer-profile.routes').then(r => r.customerProfileRoutes),
    canActivate: [authGuard, customerGuard]
  },
  {
    path: 'salon',
    loadChildren: (): Promise<Routes> => import('./features/salon/salon.routes').then(r => r.salonRoutes),
    canActivate: [authGuard, salonOwnerGuard]
  },
  {
    path: 'hairdresser/onboarding',
    loadChildren: (): Promise<Routes> => import('./features/hairdresser-onboarding/hairdresser-onboarding.routes').then(r => r.hairdresserOnboardingRoutes),
    canActivate: [authGuard, hairdresserGuard, noServicesGuard]
  },
  {
    path: 'hairdresser/salon',
    loadChildren: (): Promise<Routes> => import('./features/hairdresser-salon/hairdresser-salon.routes').then(r => r.hairdresserSalonRoutes),
    canActivate: [authGuard, hairdresserGuard, hasServicesGuard]
  },
  {
    path: 'profile/hairdresser',
    loadChildren: (): Promise<Routes> => import('./features/hairdresser-profile/hairdresser-profile.routes').then(r => r.hairdresserProfileRoutes),
    canActivate: [authGuard, hairdresserGuard, hasServicesGuard]
  },
  {
    path: 'terms',
    loadChildren: () => import('./features/terms/terms.routes').then(r => r.TERMS_ROUTES)
  },
  {
    path: 'privacy',
    loadChildren: () => import('./features/privacy/privacy.routes').then(r => r.PRIVACY_ROUTES)
  },
  {
    path: 'reviews',
    loadChildren: () => import('./features/reviews/reviews.routes').then(r => r.reviewsRoutes),
    canActivate: [noHairdresserGuard]
  },
  {
    path: 'contact',
    loadChildren: () => import('./features/contact/contact.routes').then(r => r.CONTACT_ROUTES)
  },
  {
    path: 'hairdresser/subscription',
    loadChildren: (): Promise<Routes> => import('./features/subscription/subscription.routes').then(r => r.subscriptionRoutes),
    canActivate: [authGuard, hairdresserGuard]
  },
  {
    path: 'subscription/success',
    loadChildren: (): Promise<Routes> => import('./features/subscription/subscription.routes').then(r => r.subscriptionSuccessRoutes)
  },
  {
    path: 'subscription/cancel',
    redirectTo: '/hairdresser/subscription',
    pathMatch: 'full'
  },
  {
    path: 'delete-account',
    loadChildren: () => import('./features/account-deletion/account-deletion.routes').then(r => r.ACCOUNT_DELETION_ROUTES)
  },
  {
    path: 'directory',
    loadChildren: () => import('./features/directory/directory.routes').then(r => r.DIRECTORY_ROUTES),
    canActivate: [noHairdresserGuard]
  },
  {
    path: '**',
    component: NotFoundComponent
  }
];
